import { useCallback, useEffect, useState } from 'react';
import { QuoteEditorService } from 'services/quote-editor.service';
import { IQuoteItemOriginalAttributes } from 'types/quoteEditor.types';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

export const useQuoteItemOriginalAttributes = (quoteItemId?: number | null) => {
  const [originalAttributes, setOriginalAttributes] = useState<IQuoteItemOriginalAttributes | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  const fetchOriginalAttributes = useCallback(async (itemId?: number | null) => {
    if (!itemId) {
      setOriginalAttributes(undefined);
      return;
    }

    setIsLoading(true);
    try {
      const response = await QuoteEditorService.getQuoteItemOriginalAttributes(itemId);
      if (response) setOriginalAttributes(response);
    } catch {
      displayErrorNotification();
      setOriginalAttributes(undefined);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOriginalAttributes(quoteItemId);
  }, [quoteItemId, fetchOriginalAttributes]);

  return {
    originalAttributes,
    isLoading,
    refetch: () => fetchOriginalAttributes(quoteItemId)
  };
};
